import React, { useEffect, useState } from 'react';
import HireTalentLayout from '../../../layouts/HireTalentLayout';
import JobFilter from '../../../components/pages/hire-talent/JobFilter';
import TableHeader from '../../../components/table/tableHeader';
import { useDispatch, useSelector } from 'react-redux';
import PostNewJob from '../../../components/Modals/common/jobpost';
import { deleteJobPostByHireTalent, getJobPostData, updateJobPostByHireTalent } from '../../../redux/features/hire-talent/actions/authAction';
import Loader from '../../../components/loader';
import ReactPagination from '../../../components/table/ReactPagination';
import PaginationDropdown from '../../../components/table/PaginationDropdown';
import NoRecord from '../../../components/form/NoRecord';
import ConfirmationModal from '../../../components/Modals/common/webinar/ConfirmationModal';
import { useNavigate } from 'react-router-dom';
import { hireTalentPaths } from '../../../routes/hire-talent';

const JobPost = () => {
    const { subLoading, jobPostList, JobHeader } = useSelector((state) => state.hireTalent.auth);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const tabs = [
        {
            lable: "All",
            value: "all",
        },
        {
            lable: "Open",
            value: "Open",
        },
        {
            lable: "Active",
            value: "Active",
        },
        {
            lable: "Created",
            value: "Created",
        },
        // {
        //     lable: "Scheduled",
        //     value: "Scheduled",
        // },
        {
            lable: "Paused",
            value: "Paused",
        },
        {
            lable: "Draft",
            value: "Draft",
        },
        {
            lable: "Expired",
            value: "Expired"
        },
        {
            lable: "Closed",
            value: "Closed",
        }
    ];

    const [isJobPostUpdate, setIsJobPostUpdate] = useState(false);
    const [activeTab, setActiveTab] = useState(tabs[0]?.value);
    const [listPerPages, setListPerPages] = useState(5);
    const [isJobPost, setIsJobPost] = useState(false);
    const [currentPage, setCurrentPage] = useState(0);
    const [jobPostDetails, setJobPostDetails] = useState({});
    const [id, setId] = useState();

    const handlePageClick = (data) => {
        setCurrentPage(data?.selected);
    };

    useEffect(() => {
        dispatch(getJobPostData());
    }, [dispatch]);

    const paginatedList =
        jobPostList[activeTab]?.slice(
            currentPage * listPerPages,
            (currentPage + 1) * listPerPages
        ) || [];

    const handleDeleteJobPost = () => {
        const callback = (response) => {
            dispatch(getJobPostData());
        };
        dispatch(deleteJobPostByHireTalent({ params: id, callback }));
    };

    const handleChangeValue = (value, item) => {
        const data = {
            job_title: item?.job_title || "",
            industry: item?.industry || "",
            category: item?.category || "",
            candidate_location: item?.candidate_location || "",
            candidate_availability: item?.candidate_availability || "",
            job_description: item?.job_description || "",
            years_of_experience: item?.years_of_experience || "",
            minimum_education: item?.minimum_education || "",
            salary_currency: item?.salary_currency || "",
            min_salary: item?.min_salary || "",
            max_salary: item?.max_salary || "",
            start_date: item?.start_date || "",
            end_date: item?.end_date || "",
            status: value || item?.status
        };
        data.end_date == "" && delete data.end_date;
        const callback = (response) => {
            dispatch(getJobPostData());
        };
        dispatch(updateJobPostByHireTalent({ payload: data, callback, params: item?.id }));

    };

    return (
        <HireTalentLayout>
            {subLoading && <Loader />}
            <div class="ct_px_40 ct_mt_36">
                <div className="row">
                    <JobFilter />
                    <div className=" col-lg-9 col-md-9 mb-4 mb-md-0">
                        <div className="d-flex align-items-center gap-3 justify-content-end mb-3 ">
                            <button
                                className="ct_yellow_btn ct_h_35 "
                                onClick={() => {
                                    setIsJobPost(true)
                                    setJobPostDetails({})
                                }}
                            >
                                Post Job
                            </button>
                        </div>
                        <ul className="ct_table_filter">
                            {tabs?.map((item, ind) => (
                                <li
                                    style={{ cursor: "pointer" }}
                                    className={item?.value == activeTab ? "active" : ""}
                                    onClick={() => setActiveTab(item?.value)}
                                >
                                    {item?.lable}
                                    {jobPostList[item?.value]?.length > 0 &&
                                        `(${jobPostList[item?.value]?.length})`}
                                </li>
                            ))}
                        </ul>
                        <div className="table-responsive ct_custom_table ct_custom_table_grey pt-2">
                            <table className="table">
                                <TableHeader data={JobHeader} />
                                {paginatedList?.length > 0 && (
                                    <tbody>
                                        {paginatedList?.map((item, index) => (
                                            <tr>
                                                <td>{index + 1}</td>
                                                <td>{item?.job_title || "#N/A"}</td>
                                                <td>{item?.category || "#N/A"}</td>
                                                <td>
                                                    <select
                                                        className='form-control ct_input border-0 ct_fit_content'
                                                        value={item?.status}
                                                        onChange={(e) => handleChangeValue(e.target.value, item)}
                                                    >
                                                        {tabs?.map((items) => (
                                                            items?.lable != "All" &&
                                                            <option value={items?.value}>{items?.lable || ""}</option>
                                                        ))}
                                                    </select>
                                                </td>
                                                <td>{item?.applicant || 0}</td>
                                                <td>
                                                    {item?.candidate_location || "#N/A"}
                                                </td>
                                                <td>
                                                    <div className="ct_right_dropdown dropdown">
                                                        <button
                                                            id="dropdownMenuButton1"
                                                            data-bs-toggle="dropdown"
                                                            aria-expanded="false"
                                                        >
                                                            <i className="fa-solid fa-ellipsis"></i>
                                                        </button>
                                                        <ul
                                                            className="dropdown-menu"
                                                            aria-labelledby="dropdownMenuButton1"
                                                        >
                                                            <li>
                                                                <a className="dropdown-item"
                                                                    onClick={() => {
                                                                        navigate(hireTalentPaths.JobDetails, { state: { data: item, jobPostList: jobPostList, index: index } })
                                                                    }}
                                                                >
                                                                    View Details
                                                                </a>
                                                            </li>
                                                            <li>
                                                                <a
                                                                    className="dropdown-item ct_darksky_blue_text"
                                                                    onClick={() => {
                                                                        setJobPostDetails(item);
                                                                        setIsJobPostUpdate(true);
                                                                    }}
                                                                >
                                                                    Edit
                                                                </a>
                                                            </li>
                                                            <li>
                                                                <a
                                                                    className="dropdown-item ct_orange_text"
                                                                    // href="javascript:void(0)"
                                                                    onClick={() => {
                                                                        setId(item?.id)
                                                                    }}
                                                                    data-bs-target="#ct_remove_job"
                                                                    data-bs-toggle="modal"
                                                                >
                                                                    Remove{" "}
                                                                </a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                )}
                            </table>
                            {paginatedList?.length <= 0 && <NoRecord />}
                        </div>
                        {paginatedList?.length > 0 && (
                            <div className="d-flex justify-content-between align-items-center mt-4 ">
                                <div>
                                    <PaginationDropdown
                                        onChange={(val) => {
                                            setListPerPages(val);
                                            setCurrentPage(0);
                                        }}
                                    />
                                </div>
                                <div>
                                    <ReactPagination
                                        pageCount={Math.ceil(
                                            jobPostList[activeTab]?.length / listPerPages
                                        )}
                                        onPageChange={handlePageClick}
                                        currentPage={currentPage}
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            {
                (isJobPost || isJobPostUpdate) && (
                    <PostNewJob
                        title={isJobPostUpdate ? "Update Job" : "Create Job"}
                        onClose={() => {
                            setIsJobPost(false);
                            setIsJobPostUpdate(false);
                        }}
                        jobPostDetails={jobPostDetails}
                        isJobPostUpdate={isJobPostUpdate}
                    />
                )
            }
            <ConfirmationModal
                id="ct_remove_job"
                title="Delete Job"
                onConfirm={handleDeleteJobPost}
            />
        </HireTalentLayout >
    )
};

export default JobPost;
